import React from "react";
import { FormGroup } from "react-bootstrap";
import Label from "../Label/Label";
import InputError from "../InputError/InputError";
import Textarea from "../Textarea/Textarea";

function FormTextArea(props) {
  const {
    label,
    error,
    errorClassName,
    id,
    name,
    type,
    className,
    value,
    disabled,
    onChange,
    minLength,
    maxLength,
    checked,
    placeHolder,
    multiple,
    accept,
    rows,
  } = props;

  return (
    <FormGroup>
      {label && <Label>{label}</Label>}
      <Textarea
        id={id}
        name={name}
        type={type}
        className={className}
        value={value}
        disabled={disabled}
        onChange={onChange}
        minLength={minLength}
        maxLength={maxLength}
        checked={checked}
        placeHolder={placeHolder}
        multiple={multiple}
        accept={accept}
        rows={rows}
      />
      <InputError error={error} className={errorClassName} />
    </FormGroup>
  );
}

export default FormTextArea;
